import React, { FC, Ref } from 'react';
require("./PopupArrow.css");
var styles = {
  "Root": "PopupArrow-module-Root_KxM",
  "Path": "PopupArrow-module-Path_16A",
  "Svg": "PopupArrow-module-Svg_18l"
};
const shapes = {
  sharpen: 'M8,19H7l-6-7l6-7h1',
  round: 'M8,24c0-8.9-6-12-6-12S8,9,8,0'
};
export const PopupArrow = ({
  innerRef,
  shape = 'sharpen'
}) => {
  return /*#__PURE__*/React.createElement("span", {
    "data-popper-arrow": true,
    className: styles.Root,
    ref: innerRef
  }, /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    className: styles.Svg
  }, /*#__PURE__*/React.createElement("path", {
    className: styles.Path,
    d: shapes[shape]
  })));
};